let mainPath = "/assets";
let viewFolder = "Asset";

module.exports = [
    {
        path: mainPath,
        name: 'assets',
        component: () => import(/* webpackChunkName: "Warehouse" */ '../views/'+viewFolder+'/Index.vue'),
        // beforeEnter: (to, from, next) => {
        //   if (!localStorage.getItem('userId')) next({ name: 'Home' })
        //   else next()
        // }
    },
    {
        path: mainPath+'/history/:assetId',
        name: 'Asset History',
        component: () => import('../views/'+viewFolder+'/AssetHistory.vue')
    },
]